const isDisabled = (item, nonSelectableItems) => {
    const itemIsNotSelectable = ({id}) => id.toUpperCase() === item.id.toUpperCase()

    if (nonSelectableItems) {
        return !!nonSelectableItems.find(itemIsNotSelectable)
    }
    return false
}

const parseUserData = (user, nonSelectableItems) => ({
    ...user,
    name: user.employeeType === 'Mechanical' ? user.id : user.preferredName.full,
    profilePhotoSrc: user.photoBase64,
    type: 'user',
    isDisabled: isDisabled(user, nonSelectableItems)
})

const parseGroupData = (group, nonSelectableItems) => ({
    ...group,
    type: 'group',
    isDisabled: isDisabled(group, nonSelectableItems)
})

const parseApplicationData = (application) => ({
    ...application,
    type: 'application'
})

export {isDisabled, parseUserData, parseGroupData, parseApplicationData}
